import React from 'react';
import dayjs from 'dayjs';
import { Tag, Tooltip } from 'antd';
import {
  createColumnNumber,
  createColumnText,
  createSimpleColumnText,
  widthOptions,
} from '../../../../components/table/function/createColumn';
import { color } from '../../../../resources';

const formatQty = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return Number(value).toLocaleString('th-TH');
};

const numberColumn = (title, dataIndex, width, render) =>
  createColumnNumber(title, dataIndex, {
    noSearch: true,
    others: {
      width,
      render: render || ((value) => formatQty(value)),
    },
  });

export const stockClaimColumns = () => [
  createColumnText('รหัสสินค้า', 'itemId', { noSearch: true, ...widthOptions(140) }),
  createColumnText('ชื่อสินค้า', 'itemName', { noSearch: true, ...widthOptions(220) }),
  createSimpleColumnText('รุ่นมือถือ', 'mobileModel', {
    width: 180,
    render: (_value, record) =>
      [record?.mobileBrand, record?.mobileModel].filter(Boolean).join(' / ') || '-',
  }),
  createColumnText('บริษัท', 'company', { noSearch: true, ...widthOptions(120) }),
  numberColumn('คงเหลือ', 'availableQty', 110),
  numberColumn('รอส่ง CS', 'pendingQty', 110),
  numberColumn('คงเหลือสุทธิ', 'netAvailableQty', 120),
  numberColumn('จองโดยเคลม', 'reservedQty', 140, (value, record) => (
    <Tooltip title={(record?.reservedClaimCodes ?? []).join(', ') || 'ไม่มีรายการจอง'}>
      <span>{formatQty(value)}</span>
    </Tooltip>
  )),
  numberColumn('ใช้ได้จริง', 'effectiveAvailableQty', 120, (effectiveAvailableQty) => (
    <span style={{ color: effectiveAvailableQty < 0 ? color.red2 : 'inherit', fontWeight: 600 }}>
      {formatQty(effectiveAvailableQty)}
    </span>
  )),
  createSimpleColumnText('อัปเดตล่าสุด', 'updatedAt', {
    width: 190,
    render: (value, record) => (
      <span>
        {value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '-'}
        {record?.stale && (
          <Tag color="orange" style={{ marginLeft: 8 }}>
            ข้อมูลเก่า
          </Tag>
        )}
      </span>
    ),
  }),
];
